import * as React from 'react';
import { BestDeterminer } from '../lib/determiner';
import { BaseRow, BaseRowFactory } from './BaseRow';
import { AdvancedRulerRowFactory } from './rows/AdvancedRulerRow';
import { MoreRowFactory } from './rows/MoreRow';
import { PatternRowFactory } from './rows/PatternRow';
import { SchrodingerCatRowFactory } from './rows/SchrodingerCatRow';
import { UUIDRowFactory } from './rows/UUIDRow';

export interface RandomProps {
}

interface RandomStateRow<T extends BaseRowFactory = BaseRowFactory> {
  type: T
  title?: string
  titleMonospaced?: boolean
  data: T['TData']
  input: T['TInput']
  display: T['TDisplay'],
  style?: React.CSSProperties,
  className?: string
}

export interface RandomState {
  rowKeys: string[],
  rows: {
    [key: string]: RandomStateRow
  }
}

export default class Random extends React.Component<RandomProps, RandomState> {
  state: RandomState = {
    rowKeys: [],
    rows: {}
  }

  componentDidMount() {
    this.setState({
      rowKeys: [],
      rows: {}
    });

    // this.appendRow(`Ruler`, { type: new RulerRowFactory() });
    // this.appendRow(`Hex Ruler`, { type: new RulerRowFactory(), display: { radix: 16, count: 5, color: "blue" } });
    this.appendRow(`ruler1`, { title: " ", type: new AdvancedRulerRowFactory() });
    this.appendRow(`00101010`, { titleMonospaced: true, type: new PatternRowFactory(), input: { length: 80, pattern: BestDeterminer.patternNumber } });
    this.appendRow(`olololol`, { titleMonospaced: true, type: new PatternRowFactory(), input: { length: 80, pattern: BestDeterminer.patternLowercaseAlphabet } });
    this.appendRow(`OLOLOLOL`, { titleMonospaced: true, type: new PatternRowFactory(), input: { length: 80, pattern: BestDeterminer.patternUppercaseAlphabet } });
    // this.appendRow(`ololOLOL`, { titleMonospaced: true, type: new PatternRowFactory(), input: { length: 80, pattern: BestDeterminer.patternAlphabet } });
    // this.appendRow(`olol0010`, { titleMonospaced: true, type: new PatternRowFactory(), input: { length: 80, pattern: BestDeterminer.patternLowercaseAlphabetNumber } });
    // this.appendRow(`OLOL1010`, { titleMonospaced: true, type: new PatternRowFactory(), input: { length: 80, pattern: BestDeterminer.patternUppercaseAlphabetNumber } });
    // this.appendRow(`olOL0010`, { titleMonospaced: true, type: new PatternRowFactory(), input: { length: 80, pattern: BestDeterminer.patternAlphabetNumber } });
    // this.appendRow(`olOL10-=`, { titleMonospaced: true, type: new PatternRowFactory(), input: { length: 80, pattern: [BestDeterminer.patternProgrammerSymbol, ...BestDeterminer.patternAlphabetNumber] } });
    // this.appendRow(`olOL10\\"`, { titleMonospaced: true, type: new PatternRowFactory(), input: { length: 80, pattern: [BestDeterminer.patternSymbol, ...BestDeterminer.patternAlphabetNumber] } });
    this.appendRow(`abcdABCD`, { titleMonospaced: true, type: new PatternRowFactory(), input: { length: 80, pattern: BestDeterminer.patternNonSimilarAlphabet } });
    this.appendRow(`abcd9876`, { titleMonospaced: true, type: new PatternRowFactory(), input: { length: 80, pattern: BestDeterminer.patternNonSimilarLowercaseAlphabetNumber } });
    // this.appendRow(`ABCD5432`, { titleMonospaced: true, type: new PatternRowFactory(), input: { length: 80, pattern: BestDeterminer.patternNonSimilarUppercaseAlphabetNumber } });
    this.appendRow(`abAB9876`, { titleMonospaced: true, type: new PatternRowFactory(), input: { length: 80, pattern: BestDeterminer.patternNonSimilarAlphabetNumber } });
    this.appendRow(`abAB98-=`, { titleMonospaced: true, type: new PatternRowFactory(), input: { length: 80, pattern: [BestDeterminer.patternProgrammerSymbol, ...BestDeterminer.patternNonSimilarAlphabetNumber] } });
    // this.appendRow(`abAB98\\"`, { titleMonospaced: true,  type: new PatternRowFactory(), input: { length: 80, pattern: [BestDeterminer.patternSymbol, ...BestDeterminer.patternNonSimilarAlphabetNumber] } });

    this.appendRow(`ruler2`, { title: " ", type: new AdvancedRulerRowFactory() });

    this.appendRow(`UUIDv1`, { type: new UUIDRowFactory(), input: { version: 1 }, className: "no-ruler" });
    this.appendRow(`UUIDv4`, { type: new UUIDRowFactory(), input: { version: 4 }, className: "no-ruler" });
    this.appendRow(`GUID`, { type: new UUIDRowFactory(), input: { version: 0 }, className: "no-ruler" });

    // this.appendRow(`Steam Key`, {
    //   type: new CDKeyRowFactory(), input: {
    //     mask: "#####-#####-#####",
    //     pattern: {
    //       "#": "023456789ABCDEFGHIJKLMNPQRTVWXYZ",
    //     }
    //   }, className: "no-ruler"
    // });

    // this.appendRow(`Desura Key`, {
    //   type: new CDKeyRowFactory(), input: {
    //     mask: "#####-#####-#####-#####-#####",
    //     pattern: {
    //       "#": "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    //     }
    //   }, className: "no-ruler"
    // });

    // this.appendRow(`CoolQ Key`, {
    //   type: new CDKeyRowFactory(), input: {
    //     mask: "#####-#####-#####-#####-#####",
    //     pattern: {
    //       "#": "12345678ABCDEFGHIJKMNOPQRSTUVWXY",
    //     }
    //   }, className: "no-ruler"
    // });

    // // https://www.techtalkz.com/threads/alphabet-letters-not-used-in-microsoft-product-keys.82675/
    // this.appendRow(`MS ProdKey`, {
    //   type: new CDKeyRowFactory(), input: {
    //     mask: "#####-#####-#####-#####-#####",
    //     pattern: {
    //       "#": "2346789BCDFGHJKMPQRTVWXY",
    //     }
    //   }, className: "no-ruler"
    // });
    // this.appendRow(`MS ProdID`, {
    //   type: new CDKeyRowFactory(), input: {
    //     mask: "XXXXX-XXX-XXXXXXX-XXXXX",
    //     pattern: {
    //       "X": "0123456789",
    //     }
    //   }, className: "no-ruler"
    // });
    // this.appendRow(`MS PhoneAct Req1`, {
    //   type: new CDKeyRowFactory(), input: {
    //     mask: "XXXXXX XXXXXX XXXXXX XXXXXX XXXXXX XXXXXX XXXXXX XXXXXX XXXXXX",
    //     pattern: {
    //       "X": "0123456789",
    //     }
    //   }, className: "no-ruler"
    // });
    // this.appendRow(`MS PhoneAct Req2`, {
    //   type: new CDKeyRowFactory(), input: {
    //     mask: "XXXXXXX XXXXXXX XXXXXXX XXXXXXX XXXXXXX XXXXXXX XXXXXXX XXXXXXX XXXXXXX",
    //     pattern: {
    //       "X": "0123456789",
    //     }
    //   }, className: "no-ruler"
    // });
    // this.appendRow(`MS PhoneAct Res`, {
    //   type: new CDKeyRowFactory(), input: {
    //     mask: "XXXXXX XXXXXX XXXXXX XXXXXX XXXXXX XXXXXX XXXXXX XXXXXX",
    //     pattern: {
    //       "X": "0123456789",
    //     }
    //   }, className: "no-ruler"
    // });

    // this.appendRow(`WordPress SecretKey`, {
    //   type: new WordPressRowFactory(), className: "no-ruler"
    // });

    this.appendRow(`Schrödinger's Cat`, {
      type: new SchrodingerCatRowFactory(), className: "no-ruler",
      input: {
        attempt: 1000
      }
    });

    this.appendRow(`More`, {
      type: new MoreRowFactory(), className: "no-ruler",
    });

    // this.appendRow(`ruler99`, { title: " ", type: new AdvancedRulerRowFactory() });
    this.regenerateAll();
  }

  rowNodes: { [key: string]: BaseRow<any> | null } = {}

  appendRow<T extends BaseRowFactory>(key: string, rowState: Partial<RandomStateRow<T>>) {
    return this.setState((state) => {
      if (state.rowKeys.indexOf(key) >= 0) throw new Error('Duplicated key');
      return {
        rowKeys: [...state.rowKeys, key],
        rows: {
          ...state.rows,
          [key]: {
            ...rowState as RandomStateRow<T>,
            input: rowState.type!.convertDisplay(rowState.input),
            display: rowState.type!.convertDisplay(rowState.display),
          }
        }
      }
    })
  }

  setRowState(key: string, rowChange: Partial<RandomStateRow>) {
    return this.setState((state) => ({
       rows: {
         ...state.rows,
         [key]: {
           ...state.rows[key],
           ...rowChange
          }
        }
      }
    ))
  }

  regenerateAll() {
    this.setState((state) => {
      const change = { rows: {...state.rows} };
      for(const key of state.rowKeys) {
        const factory = change.rows[key].type;

        change.rows[key] = {
          ...change.rows[key],
          data: factory.generate(change.rows[key].input)
        };
      }
      return change;
    })
  }

  renderRows() {
    const length = this.state.rowKeys.length;
    return <>
      <div className="data-background" style={{
        gridRowStart: 1,
        gridRowEnd: length + 2
      }}></div>
      {this.state.rowKeys.map((key, index) => {
        const row = this.state.rows[key]
        return <row.type.component
          style={{
            ...row.style,
            gridRow: index + 1
          }}
          className={row.className}
          key={key}
          name={key}
          title={row.title}
          titleMonospaced={row.titleMonospaced}
          ref={(node) => this.rowNodes[key] = node}
          data={row.data}
          setData={(data) => this.setRowState(key, { data })}
          input={row.input}
          setInput={(input) => this.setRowState(key, { input })}
          display={row.display}
          setDisplay={(display) => this.setRowState(key, { display })}
        ></row.type.component>;
      })}
      {/* <>
        <div className="row-header dummy"
          style={{ gridRow: length + 1 }}
        >Notepad</div>
        <div className="row-data dummy"
          style={{ gridRow: length + 1 }}
        ><textarea style={{ width: "80ch" }}></textarea></div>
      </> */}
    </>
  }

  render() {
    return <>
      <div className="main-nav">
        <button onClick={() => {
          this.regenerateAll();
        }}>Generate</button>
      </div>
      <div className="main-result">
        {this.renderRows()}
      </div>
    </>;
  }
}
